import { apiCall, createQueryString } from "./../imports";
const PREFIX = "management/contacts";

export default {
  getContacts(data) {
    return apiCall("get", `${PREFIX}${createQueryString(data)}`);
  },

  deleteContacts(id) {
    return apiCall("delete", `${PREFIX}/${id}`);
  },
};
